import React from "react";
import { useQuery } from "@apollo/client";
import { Link } from "@reach/router";
import { PropertyDuplicatesCount } from "types/gql-types";
import { PROPERTY_DUPLICATES_COUNT } from "pages/duplicates/queries";

const Duplicates: React.FC<{ interestListId: string }> = (props) => {
  const { data, loading, error } = useQuery<PropertyDuplicatesCount>(PROPERTY_DUPLICATES_COUNT, {
    variables: { id: props.interestListId },
  });

  if (error) return <span>Error loading duplicates</span>;
  if (!data || loading) return null;

  const listId = data.interestList.id;

  return (
    <Link to={`/dash/manager/duplicates/${listId}`} style={{ marginRight: 20 }}>
      Duplicates ({data.interestList?.property?.duplicatesCount})
    </Link>
  );
};

export default Duplicates;
